document.addEventListener("DOMContentLoaded", function () {
    const bannerLinks = document.querySelectorAll(".kw-banner-link");
  
    bannerLinks.forEach(function (link) {
      link.addEventListener("click", async function (event) {
        event.preventDefault();
  
        // Check options by priority
        const productUrl = link.getAttribute("data-product-url");
        const couponCode = link.getAttribute("data-coupon");
        const linkUrl = link.getAttribute("href");
  
        try {
          // Priority 1: Add product to cart if product is selected
          if (productUrl) {
            link.style.cursor = 'wait';
  
            // Fetch product data
            const response = await fetch(productUrl + ".js");
            const productData = await response.json();
            const variantId = productData.variants[0].id;
  
            // Add to cart using fetch
            const cartResponse = await fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                items: [{
                  id: variantId,
                  quantity: 1
                }]
              })
            });
  
            // Get updated cart data
            const cartState = await fetch('/cart.js').then(res => res.json());
  
            // Update or create cart count bubble
            let cartCountBubble = document.querySelector('.cart-count-bubble');
            if (!cartCountBubble) {
              cartCountBubble = document.createElement('div');
              cartCountBubble.className = 'cart-count-bubble';
              const cartIcon = document.querySelector('#cart-icon-bubble');
              if (cartIcon) cartIcon.appendChild(cartCountBubble);
            }
  
            cartCountBubble.innerHTML = `
              <span aria-hidden="true">${cartState.item_count}</span>
              <span class="visually-hidden">Št. elementov: ${cartState.item_count}</span>
            `;
  
            // Update cart drawer contents
            const drawerResponse = await fetch(`${routes.cart_url}?section_id=cart-drawer`);
            const responseText = await drawerResponse.text();
            const html = new DOMParser().parseFromString(responseText, "text/html");
  
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) {
              const drawerInner = cartDrawer.querySelector('.drawer__inner');
              const newDrawerInner = html.querySelector('.drawer__inner');
              if (drawerInner && newDrawerInner) {
                drawerInner.replaceWith(newDrawerInner);
              }
              cartDrawer.classList.remove('is-empty');
              cartDrawer.classList.add('animate', 'active');
              document.body.classList.add('overflow-hidden');
            }
  
            initUUCartAddons();
          }
          // Priority 2: Apply coupon if coupon code is set
          else if (couponCode) {
            // Show coupon success message if it exists
            const couponMessage = link.closest('.kw-image-banner').querySelector('.kw-coupon-message');
            if (couponMessage) {
              couponMessage.style.display = 'block';
            }
            
            // Apply coupon code to cart
            window.location.href = `/discount/${couponCode}`;
          }
          // Priority 3: Navigate to link URL if set
          else if (linkUrl && linkUrl !== 'javascript:void(0);') {
            window.location.href = linkUrl;
          }
  
        } catch (error) {
          console.error("Error:", error);
        } finally {
          link.style.cursor = '';
        }
      });
    });
  });
  